import { BaseTheme } from "./BaseTheme";
import { ITheme } from "./ThemeTypes";

export const DarkTheme: ITheme = {
  name: "DarkTheme",
  base: BaseTheme,
  colors: {
    outline: "142, 145, 153",
    outline_variant: "67, 71, 78",
    surface: "16, 20, 20",
    surface_container: "31, 35, 35",
    surface_container_high: "39, 43, 43",
    on_surface_variant: "196, 198, 207",
    on_surface: "196, 199, 199",
    primary: "167, 200, 255",
    on_primary: "0, 48, 96",
    primary_container: "0, 71, 136",
    on_primary_container: "213, 227, 255",
    secondary_container: "82, 71, 0",
    on_secondary_container: "255, 226, 67",
    tertiary_container: "147, 0, 6",
    on_tertiary_container: "255, 218, 213",
    surface_variant: "67, 71, 78",
    on_surface_variant_opacity_0_08: "rgba(202, 196, 208, 0.08)",
    inverse_surface: "224, 227, 227",
    inverse_on_surface: "25, 28, 29",
    scrim: "0, 0, 0",
    error: "255, 180, 170",
  },
  opacity: {
    opacity_percent_1: 70,
  },
};
